var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 116,
    viewBox: "0 0 97 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAC600",
    d: "M2.989 88.951l45.553-21.106 45.554 21.106a3.99 3.99 0 0 1 0 7.24l-39.683 18.387a13.965 13.965 0 0 1-11.741 0L2.989 96.192a3.99 3.99 0 0 1 0-7.24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M23.514 93.906c8.565 3.02 17.13 4.529 25.693 4.529 8.565 0 17.13-1.51 25.694-4.53a1.995 1.995 0 0 0 1.244-2.465L50.787 8.68c-.69.25-1.216.373-1.58.37-.364-.002-.874-.133-1.53-.391L22.27 91.44a1.995 1.995 0 0 0 1.244 2.466z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FAC600",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 11.97,
    d: "M30.973 96.754C37.05 98.318 43.129 99.1 49.207 99.1c6.08 0 12.16-.782 18.239-2.347a9.31 9.31 0 0 0 6.586-11.728L50.786 8.681C50.043 6.896 49.49 6.002 49.126 6c-.364-.002-.847.884-1.449 2.66l-23.29 76.362a9.31 9.31 0 0 0 6.586 11.732z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FF9A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 11.97,
    d: "M29.59 67.845l.947.374a50.883 50.883 0 0 0 38.318-.374M38.235 39.915l.547.19a31.715 31.715 0 0 0 21.428-.19",
    style: {
      mixBlendMode: "multiply"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCone);
export default __webpack_public_path__ + "static/media/cone.ab874cd8fe4e067ab6f63c4bd20d19f7.svg";
export { ForwardRef as ReactComponent };